import React from "react";
//#region types
import { InvoiceLayoutSelectorProps } from "models/propTypes/invoicePropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Icon } from "components/common";
import { Grid, Card, CardContent, ButtonBase } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { EnumHelper, LocalizationHelperInstance } from "utils/helpers";
import InvoiceLayoutClassicImg from "images/invoiceLayout_Classic.png";
import InvoiceLayoutDefaultImg from "images/invoiceLayout_Default.png";

const InvoiceLayoutSelector: React.FC<InvoiceLayoutSelectorProps> = (props) => {
  const handleClick = (type: WintSuperkollAPIModel.InvoicePdfTemplate, e: React.MouseEvent<HTMLDivElement>) => {
    props.onChange(type);
    props.onBlur();
  };

  const getImage = (type: WintSuperkollAPIModel.InvoicePdfTemplate) => {
    switch (type) {
      case WintSuperkollAPIModel.InvoicePdfTemplate.Default:
        return InvoiceLayoutDefaultImg;
      case WintSuperkollAPIModel.InvoicePdfTemplate.Classic:
        return InvoiceLayoutClassicImg;
      default:
        return InvoiceLayoutDefaultImg;
    }
  };

  return (
    <Grid
      item
      container
      className={clsx(cssExports.selectionChipsGroup, cssExports.invoiceLayoutSelection)}
      spacing={2}
    >
      {EnumHelper.getItems(WintSuperkollAPIModel.InvoicePdfTemplate).length > 0
        ? EnumHelper.getItems(WintSuperkollAPIModel.InvoicePdfTemplate).map((key) => {
            const item =
              WintSuperkollAPIModel.InvoicePdfTemplate[key as keyof typeof WintSuperkollAPIModel.InvoicePdfTemplate];
            const isSelected = props.value === item;
            return (
              <Grid key={item} container item xs={6}>
                <ButtonBase
                  component={"div"}
                  style={{ display: "block", height: "100%", width: "100%" }}
                  onClick={handleClick.bind(null, item)}
                  data-key={item}
                >
                  <Card className={clsx(cssExports.selectionTile, isSelected ? cssExports.selected : "")}>
                    <CardContent className={cssExports.selectionTileContent}>
                      <Grid container direction="column">
                        <Grid container direction="row-reverse" className={cssExports.selectionTileIcons}>
                          <Grid item className={cssExports.selectionIcon}>
                            {isSelected ? (
                              <Icon icon={IconDefinitionConstants.WCheckCanvas} />
                            ) : (
                              <Icon icon={IconDefinitionConstants.WCheckEmpty} />
                            )}
                          </Grid>
                          <Grid item xs className={cssExports.selectionTileText}>
                            {LocalizationHelperInstance.getFormattedMessage(`Invoice.InvoiceLayout_${item}`)}
                          </Grid>
                        </Grid>

                        <Grid item className={cssExports.selectionTileImage}>
                          <img src={getImage(item)} draggable={false} />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </ButtonBase>
              </Grid>
            );
          })
        : ""}
    </Grid>
  );
};

export default InvoiceLayoutSelector;
